<template>
  <div class="tariff-table table"
       :class="'table__tariff-count_' + getListTariff.length"
  >
    <div class="button button__theme_scroll button__theme_scroll-left"
         @click="scrollTable('left')"
    >
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0586 3.75L5.25 9L10.0586 14.25L11.25 12.9492L7.63281 9L11.25 5.05077L10.0586 3.75Z" fill="#AEBCD6"/>
      </svg>
    </div>

    <div class="button button__theme_scroll button__theme_scroll-right"
         @click="scrollTable('right')"
    >
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.94141 14.25L12.75 9L7.94141 3.75L6.75 5.05077L10.3672 9L6.75 12.9492L7.94141 14.25Z" fill="#AEBCD6"/>
      </svg>
    </div>

    <div class="table_container"
         id="tariff-table"
    >
      <div class="table_row table_row__theme_header table_row__theme_light-purple">
        <div class="table_cell"></div>

        <div class="table_cell table_cell__theme_tariff"
             :class="{
                'table_cell__active': idSelectedTariff === item.id
              }"
             :id="'table_cell_' + i"
             v-for="(item, i) in getListTariff"
             :key="'header_tariff_' + item.id"
        >
          <div class="block block__selected">
            <div class="line line-top"></div>
            <div class="line line-right"
                  :style="{height: (tableHeight - 1) + 'px'}"
            ></div>
            <div class="line line-bottom"
                 :style="{top: (tableHeight - 1) + 'px'}"
            ></div>
            <div class="line line-left"
                  :style="{height: (tableHeight - 1) + 'px'}"
            ></div>
          </div>

          <div class="additional additional__installment-payment"
               v-if="item.installmentAvailable"
          >
            <BlockAdditional
              :type="'installmentPayment'"
              :text="'На этот тариф доступна беспроцентная рассрочка от банков партнёров'"
            ></BlockAdditional>
          </div>

          <div class="cell-container">
            <div class="image"
                 :style="{backgroundImage: `url('${ item.image }')`}"
            ></div>

            <span class="text text__h3 text__title text__center">{{ item.title }}</span>
            <span class="text text__h3 text__cost text__center">{{ `${ item.costString } ₽` }}</span>

            <div class="button button__select_tariff"
                 @click="changeTariff(item.id)"
            >
              <div class="block block__checkbox">
                <div class="svg">
                  <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.56216 0.887695L4.0335 6.41636L1.83816 4.22103L0.64801 5.41118L4.0335 8.79667L10.7523 2.07785L9.56216 0.887695Z" fill="#8C71FE"/>
                  </svg>
                </div>
              </div>

              <span class="text"
                    v-if="idSelectedTariff === item.id"
                    :key="'text_first_' + item.id"
              >Выбрано</span>

              <span class="text"
                    v-else
                    :key="'text_second_' + item.id"
              >Выбрать</span>
            </div>

            <div class="block block__benefit"
                 v-if="item.saleBenefit && (item.saleBenefit > 0)"
            >
              <span class="text text__h4 text__bold">{{ `Выгода: ${ item.saleBenefit } ₽` }}</span>

              <div class="additional additional__benefit">
                <BlockAdditional
                  :type="'benefit'"
                  :text="'При покупке всего курса обучения вы сэкономите ' + item.saleBenefit + ' рублей, в отличии от ежемесячной оплаты'"
                ></BlockAdditional>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table_content"
           v-for="item in featureList"
           :key="'feature_' + item.id"
      >
        <div class="table_row table_row__theme_light-purple">
          <div class="table_cell table_cell__theme_title">
            <span class="text text__h4 text__bold">{{ item.title }}</span>
          </div>

          <div class="table_cell"
               v-for="item in getListTariff.length"
               :key="'table_content_cell_' + item"
          ></div>
        </div>

        <div class="table_row"
             v-for="elem in item.children"
             :key="'table_content_' + item.id + '_' + elem.id"
        >
          <div class="table_cell table_cell__theme_title">
            <span class="text text__h4">{{ elem.title }}</span>
          </div>

          <div class="table_cell"
               v-for="tariff in getListTariff"
               :key="'table_content_cell_' + tariff.id"
          >
          <span class="text text__h4 text__center"
                v-if="tariff.featureList[elem.id].type === 'text'"
          >
            {{ tariff.featureList[elem.id].value }}
          </span>

            <div class="svg cell-svg"
                 v-else-if="tariff.featureList[elem.id].type === 'svg'"
            >
              <svg class="check-mark" v-if="tariff.featureList[elem.id].value" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0933 5.83105L9.80028 14.1241L6.50728 10.8311L4.72205 12.6163L9.80028 17.6945L19.8785 7.61628L18.0933 5.83105Z" fill="#89CE54"/>
              </svg>

              <svg class="cross-mark" v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.2502 5L11.9994 10.25L6.74984 5L5 6.75L10.2495 12L5 17.25L6.74984 19L11.9994 13.75L17.2502 19L19 17.25L13.7505 12L19 6.75L17.2502 5Z" fill="#FF6597"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockAdditional from "./BlockAdditional";

export default {
  name: "TariffTable",

  props: {
    idSelectedTariff: { // id выбранного курса
      type: Number,
      default: () => {
        return undefined
      },
    },

    listTariff: { // список курсов
      type: Array,
      default: () => {
        return []
      },
    },

    featureList: { // список особенностей тарифов
      type: Array,
      default: () => {
        return []
      },
    },

    firstSwitchActive: { // активен первый switch?
      type: Boolean,
      default: () => {
        return false
      }
    }
  },

  data() {
    return {
      tableHeight: undefined, // высота таблицы
    }
  },

  created() {

  },

  mounted() {
    this.calculationTableHeight();
    window.addEventListener('resize', this.calculationTableHeight)
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.calculationTableHeight)
  },

  watch: {
    firstSwitchActive() {
      this.$nextTick(() => this.calculationTableHeight());
    },
  },

  methods: {
    /** Сменить тариф
     * @param {Number} idTariff - id выбираемого тарифа
     * */
    changeTariff(idTariff) {
      if (idTariff !== this.idSelectedTariff) this.$emit('changeTariff', idTariff);
    },

    /** Рассчитывает высоту таблицы
    * */
    calculationTableHeight() {
      let table = document.getElementById('tariff-table');
      this.tableHeight = table.offsetHeight;
    },

    /** Проскролить таблицу
     * @param {String} type - тип / left - влево / right - вправо
     * */
    scrollTable(type) {
      const table = document.getElementById('tariff-table');
      const cell = document.getElementById('table_cell_0');

      if (table && cell) {
        const widthCell = cell.offsetWidth;

        if (type === 'left') table.scrollLeft -= widthCell;
        else table.scrollLeft += widthCell;
      }
    },
  },

  computed: {
    /** Получить список тарифов
     * */
    getListTariff() {
      return this.listTariff.filter(item => {
        if (this.firstSwitchActive && (item.countMonth === 1)) return true
        if (!this.firstSwitchActive && (item.countMonth !== 1)) return true // 3 / 4 месяца
      })
    },
  },

  components: {
    BlockAdditional,
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../style/variables";

.tariff-table {
  display: flex;
  flex-direction: column;
  border: 1px solid $color_purple_bg_1;
  border-radius: 8px;
  width: 100%;
  margin-top: 24px;
  background-color: white;
  position: relative;
}

.table_row__theme_header {
  border-radius: 8px 8px 0 0;
}

.table_container {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: hidden;
}

.table_container::-webkit-scrollbar {
  height: 6px;
  cursor: default !important;
}

.table_container::-webkit-scrollbar-track {
  background: $color_purple_bg_1;
  border-radius: 4px 0 0 4px;
  overflow: hidden;
  cursor: default !important;
}

.table_container::-webkit-scrollbar-thumb {
  background-color: $color_cyanite_3;
  border-radius: 3px;
  cursor: default !important;
}

.button__theme_scroll {
  display: none;
}

.table_row__theme_light-purple {
  background-color: $color_purple_bg_3;
}

.svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.table_row {
  display: grid;
  align-items: center;
  width: fit-content;
  min-width: 100%;
  position: relative;

  &:not(:first-child) {
    border-top: 1px solid $color_purple_bg_1;
  }
}

.table__tariff-count_4 .table_row {
  display: grid;
  grid-template-columns: 260px minmax(182px, 1fr) minmax(182px, 1fr) minmax(182px, 1fr) minmax(182px, 1fr);
}

.table__tariff-count_3 .table_row {
  display: grid;
  grid-template-columns: 270px minmax(182px, 1fr) minmax(182px, 1fr) minmax(182px, 1fr);
}

.table__tariff-count_2 .table_row {
  display: grid;
  grid-template-columns: 280px minmax(182px, 1fr) minmax(182px, 1fr);
}

.table__tariff-count_1 .table_row {
  display: grid;
  grid-template-columns: 290px minmax(182px, 1fr);
}

.table_cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  height: calc(100% - 32px);
  position: relative;

  &:not(:first-child) {
    border-left: 1px solid $color_purple_bg_1;
  }
}

.table_cell__theme_title {
  align-items: flex-start;
  justify-content: center;
}

.block__selected {
  position: absolute;
  left: -1px;
  top: 0;
  width: calc(100% + 2px);
  z-index: 5;
  opacity: 0;
  transition: $transition_medium;

  .line {
    position: absolute;
    background-color: $color_purple_3;
  }

  .line-top {
    height: 1px;
    left: 0;
    top: 0;
    width: 100%;
  }

  .line-right {
    width: 1px;
    top: 0;
    left: auto;
    right: 0;
  }

  .line-bottom {
    height: 1px;
    left: 0;
    bottom: 0;
    width: 100%;
  }

  .line-left {
    width: 1px;
    left: 0;
    top: 0;
  }

}

.additional__installment-payment {
  position: absolute;
  right: 7px;
  top: 7px;
  z-index: 6;
  cursor: default;
}

.cell-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  z-index: 1;

  .image {
    display: flex;
    flex-direction: column;
    width: 44px;
    height: 44px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .text__h3 {
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 21px;
  }

  .text__title {
    margin-top: 9px;
  }

  .text__cost {
    margin-top: 1px;
  }

  .button__select_tariff {
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 36px;
    box-sizing: border-box;
    border: 1px solid $color_green_bg_1;
    border-radius: 6px;
    transition: $transition_medium;
    cursor: pointer;
    background-color: white;

    &:hover {
      border-color: $color_purple_3;
    }

    .text {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 19px;
      color: $color_grey_4;
      margin-left: 8px;
      transition: $transition_medium;
      min-width: 69px;
    }
  }

  .block__checkbox {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    transition: $transition_medium;
    box-sizing: border-box;
    border: 2px solid $color_grey_bg_2;
    border-radius: 2px;

    svg {
      opacity: 0;
      transition: $transition_medium;
    }
  }

  .block__benefit {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
    width: 100%;
  }
}

.table_cell__active {
  .block__selected {
    opacity: 1;
  }

  .cell-container {
    .button__select_tariff {
      background-color: $color_purple_3;
      border-color: $color_purple_3;
      cursor: default;

      &:hover {
        border-color: $color_purple_3;
      }

      .text {
        color: white;
      }
    }

    .block__checkbox {
      border-color: white;
      background-color: white;

      svg {
        opacity: 1;
        transition: $transition_medium;
      }

      .text {
        color: white;
      }
    }
  }
}

.text__h4 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
}

.text__bold {
  font-weight: 500;
}

.table_content {
  display: flex;
  flex-direction: column;
  border-top: 1px solid $color_purple_bg_1;
  width: fit-content;
  min-width: 100%;
}

.text__center {
  text-align: center;
}

@media all and (max-width: 1860px) {
  .button__theme_scroll {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    border: 1px solid $color_purple_bg_1;
    background-color: white;
    cursor: pointer;
    transition: $transition_medium;
    z-index: 8;
    position: absolute;
    top: 120px;

    &:hover {
      border-color: $color_purple_3;

      svg path {
        fill: $color_purple_3;
      }
    }

    svg path {
      transition: $transition_medium;
    }
  }

  .button__theme_scroll-left {
    left: -15px;
  }

  .button__theme_scroll-right {
    left: auto;
    right: -15px;
  }
}

@media all and (max-width: 1600px) {

}

@media all and (max-width: 1440px) {
  .table__tariff-count_4 .table_row {
    display: grid;
    grid-template-columns: 240px minmax(176px, 1fr) minmax(176px, 1fr) minmax(176px, 1fr) minmax(176px, 1fr);
  }

  .table__tariff-count_3 .table_row {
    display: grid;
    grid-template-columns: 250px minmax(176px, 1fr) minmax(176px, 1fr) minmax(176px, 1fr);
  }

  .table__tariff-count_2 .table_row {
    display: grid;
    grid-template-columns: 260px minmax(176px, 1fr) minmax(176px, 1fr);
  }

  .table__tariff-count_1 .table_row {
    display: grid;
    grid-template-columns: 270px minmax(176px, 1fr);
  }

  .cell-container .image {
    width: 38px;
    height: 38px;
  }

  .cell-container .text__h3 {
    font-size: 16px;
    line-height: 20px;
  }

  .cell-container .text__title {
    margin-top: 8px;
  }

  .cell-container .button__select_tariff {
    margin-top: 7px;
    height: 35px;
    border-radius: 4px;
  }

  .cell-container .block__checkbox {
    width: 14px;
    height: 14px;
    border: 1px solid $color_grey_bg_2;
    border-radius: 2px;

    svg {
      width: 9px;
      height: auto;
    }
  }

  .cell-container .button__select_tariff .text {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    margin-left: 8px;
    min-width: 64px;
  }

  .text__h4 {
    font-size: 14px;
    line-height: 18px;
  }

  .cell-svg svg {
    width: 22px;
    height: 22px;
  }
}

@media all and (max-width: 1280px) {

}

// tablet
@media all and (max-width: 1160px) {
  .table__tariff-count_4 .table_row {
    display: grid;
    grid-template-columns: 260px minmax(176px, 1fr) minmax(176px, 1fr) minmax(176px, 1fr) minmax(176px, 1fr);
  }

  .table__tariff-count_3 .table_row {
    display: grid;
    grid-template-columns: 270px minmax(176px, 1fr) minmax(176px, 1fr) minmax(176px, 1fr);
  }

  .table__tariff-count_2 .table_row {
    display: grid;
    grid-template-columns: 280px minmax(176px, 1fr) minmax(176px, 1fr);
  }

  .table__tariff-count_1 .table_row {
    display: grid;
    grid-template-columns: 290px minmax(176px, 1fr);
  }

  .button__theme_scroll {
    &:hover {
      border-color: $color_purple_bg_1;

      svg path {
        fill: $color_cyanite_2;
      }
    }
  }

  .cell-container .button__select_tariff {
    &:hover {
      border-color: $color_green_bg_1;
    }
  }
}

@media all and (max-width: 960px) {

}


// mobile
@media all and (max-width: 600px) {
  .table_container {
    margin-left: -15px;
    width: calc(100% + 30px);
    border-radius: 0;
  }

  .table_row__theme_header {
    background-color: white;
  }

  .table_content .table_row__theme_light-purple {
    background-color: $color_purple_bg_3;
  }

  .table_row {
    background-color: white;
  }

  .table_cell {
    padding: 14px;
    height: calc(100% - 28px);
  }

  .cell-container .image {
    width: 32px;
    height: 32px;
  }

  .cell-container .text__h3 {
    font-size: 15px;
    line-height: 19px;
  }

  .cell-container .block__benefit {
    margin-top: 10px;
  }

  .table__tariff-count_4 .table_row {
    display: grid;
    grid-template-columns: 160px minmax(162px, 1fr) minmax(162px, 1fr) minmax(162px, 1fr) minmax(162px, 1fr);
  }

  .table__tariff-count_3 .table_row {
    display: grid;
    grid-template-columns: 160px minmax(162px, 1fr) minmax(162px, 1fr) minmax(162px, 1fr);
  }

  .table__tariff-count_2 .table_row {
    display: grid;
    grid-template-columns: 160px minmax(162px, 1fr) minmax(162px, 1fr);
  }

  .table__tariff-count_1 .table_row {
    display: grid;
    grid-template-columns: 160px minmax(162px, 1fr);
  }

  .text__h4 {
    font-size: 13px;
    line-height: 17px;
  }

  .button__theme_scroll {
    top: 85px;
    border-color: $color_cyanite_2;
    background-color: white;

    &:hover {
      border-color: $color_cyanite_2;
    }
  }

  .button__theme_scroll-left {
    left: -5px;
  }

  .button__theme_scroll-right {
    right: -5px;
  }
}
</style>